import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './AddSchedule.css';
import TauriLoader2 from '../../TauriLoader2/TauriLoader2';
import TauriImage from '../../TauriImage/TauriImage';
import appURL from '../../../appURL.json';
import { transformActivities } from '../PlanningFactoryData/PlanningFactoryData';
import { getAll, syncDataToLocal } from '../../../localDB';
import { activityClassification } from '../../../visualizations/visualizations';
import AddScheduleMultipleModal from '../AddScheduleMultipleModal/AddScheduleMultipleModal';
import AddWorkWithModal from '../AddWorkWithModal/AddWorkWithModal';

const AddSchedule = ({ show, onHide, account, worksheet, selectedDate, isCreating, onAdd, onAddMultiple }) => {
    const [activities, setActivities] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState(null);
    const [notes, setNotes] = useState("");
    const [showAddMultiple, setShowAddMultiple] = useState(false);
    const formattedDate = new Date(selectedDate).toLocaleDateString("en-US", {
        weekday: "long",   // Wednesday
        month: "short",    // Aug
        day: "numeric",    // 19
        year: "numeric",   // 2025
    });

    const handleProceed = () => {
        if (!onAdd) return;
        let payload = {};

        if (selectedActivity?.Classification === activityClassification.System) {
            payload = {
                Date: selectedDate ? selectedDate.toLocaleDateString("en-CA") : null,
                AccountID: account?.ID
            };
        } else if (selectedActivity?.Classification === activityClassification.Regular) {
            payload = {
                Date: selectedDate ? selectedDate.toLocaleDateString("en-CA") : null,
                AccountID: account?.ID,
                ActivityID: selectedActivity?.ID,
                Remarks: notes
            };
        }

        onAdd(payload, selectedActivity);
    };

    const fetchOnlineActivities = async () => {
        try {
            const token = localStorage.getItem("token");
            const devId = localStorage.getItem("devId");
            const usr_g = localStorage.getItem("usr_g");
            const response = await fetch(`${appURL.API_Worksheet}/activities?g=${Number(usr_g)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'X-ETR-Device-ID': devId
                }
            });

            if (!response.ok) {
                console.log("Failed to fetch worksheet!");
                return;
            }

            const data = await response.json();

            const filteredActivities = (data.activities || []).filter(
                activity => activityClassification[activity?.classification] !== activityClassification.Event
            );

            const transformAct = await transformActivities(filteredActivities);

            if (transformAct) syncDataToLocal('Activities', transformAct);
            setActivities(transformAct);
            if (transformAct.length > 0) {
                setSelectedActivity(transformAct[0]);
            }
        } catch (err) {
            console.log(err);
        }
    }

    const fetchOfflineActivities = async () => {
        try {
            const act = await getAll("Activities");
            const filterAct = act.filter(a => a.ID !== activityClassification.Event);
            setActivities(filterAct);
        } catch (err) {
            console.log(err);
        }
    }

    const fetchData = async () => {
        const isOnline = JSON.parse(localStorage.getItem("isOnline"));
        const hasInternet = navigator.onLine;

        if (isOnline && hasInternet) {
            await fetchOnlineActivities();
        } else {
            await fetchOfflineActivities();
        }
    }

    useEffect(() => {
        fetchData(); // only load data when opening
        if (activities.length > 0) {
            setSelectedActivity(activities[0]);
        }
        setNotes("");
        setShowAddMultiple(false);
    }, [show])

    return (
        <>
            <Modal
                className='add-schedule-modal'
                show={show}
                onHide={onHide}
                size="lg"
                centered
                backdrop={isCreating ? "static" : true}   // prevent clicking outside
                keyboard={!isCreating}                    // prevent ESC
            >
                <Modal.Header>
                    Add Schedule
                </Modal.Header>
                <Modal.Body>
                    <div className="schedule-info">
                        <div className="schedule-step flex-shrink-0 me-3 me-md-2 me-lg-3">
                            {account?.Dates?.length || 0}/{account?.Customer?.Frequency_count || 0}
                        </div>
                        <div className="schedule-details">
                            <div className="account-code">{account?.Code}</div>
                            <div className="account-name">{account?.Name}</div>
                        </div>
                        <TauriImage localImage={"/Images/mdi--about-circle.svg"} alt='icon' color={"#B8CCE2"} />
                    </div>

                    <div className="schedule-options">
                        <div className="schedule-date d-flex align-items-center">
                            <TauriImage
                                localImage={"/Images/circle-check.svg"}
                                alt="icon"
                                className={"me-2"}
                            />
                            <span>{formattedDate}</span>
                        </div>

                        <div className="activity-options">
                            <div className="activity-options">
                                {activities.map((activity) => (
                                    <label key={activity.ID}>
                                        <input
                                            type="radio"
                                            name="activity"
                                            value={activity.ID}
                                            checked={selectedActivity?.ID === activity.ID}
                                            onChange={() => setSelectedActivity(activity)}
                                        />
                                        {activity.Description}
                                    </label>
                                ))}
                            </div>
                        </div>

                        {selectedActivity && selectedActivity?.Classification !== activityClassification.System && (
                            <div className='mb-3'>
                                <div className='mb-1'>Notes</div>
                                <textarea
                                    id="notes"
                                    className="form-control"
                                    rows={3}
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                />
                            </div>
                        )}

                        <div className="suggestion-box" onClick={() => setShowAddMultiple(true)}>
                            <TauriImage localImage={"/Images/ix--ai.svg"} alt='icon' />
                            <span>Suggestions are available. Click here to view.</span>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <Button className='btn-proceed d-flex align-items-center' disabled={isCreating} onClick={handleProceed}>
                        {isCreating && (
                            <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#1D5D9B" />
                        )}
                        <span className="text-nowrap">Proceed</span>
                    </Button>
                    <Button className="btn-cancel d-flex" disabled={isCreating} onClick={onHide}>
                        <span className="text-nowrap">Cancel</span>
                    </Button>
                </Modal.Footer>

                <AddScheduleMultipleModal
                    show={showAddMultiple}
                    onHide={() => setShowAddMultiple(false)}
                    account={account}
                    worksheet={worksheet}
                    isCreating={isCreating}
                    onProceed={onAddMultiple}
                    selectedActivity={selectedActivity}
                    notes={notes} />
            </Modal>
        </>
    );
};

export default AddSchedule;
